import { SCREENS } from '~/constants/screens';
import { USER_PERMISSIONS, USER_ROLES } from '~/constants/user';
import { userStore } from '~/mobx/userStore';
import { hasPermissions, hasRole } from '~/utils/helpers';

const _hasAccessToScreenByUser = (path: string) => {
  const mapScreenToRolesAndPerm: {
    [key: string]: {
      roles: string[];
      permissions: string[];
    };
  } = {
    [SCREENS.CALLCENTER() + '/orders']: {
      permissions: [],
      roles: [USER_ROLES.RESTAURANT_MANAGER, USER_ROLES.CALL_CENTER_AGENT, USER_ROLES.OPERATOR],
    },
    [SCREENS.LIVE_ORDERS()]: {
      permissions: USER_PERMISSIONS.ORDERS_VIEW,
      roles: [
        USER_ROLES.RESTAURANT_MANAGER,
        USER_ROLES.CASHIER,
        USER_ROLES.MARKETING,
        USER_ROLES.ACCOUNTING,
        USER_ROLES.CUSOMER_CARE,
        USER_ROLES.FRANCHISEE,
        USER_ROLES.OPERATOR,
      ],
    },
    [SCREENS.HISTORY()]: {
      permissions: USER_PERMISSIONS.ORDERS_VIEW,
      roles: [USER_ROLES.RESTAURANT_MANAGER, USER_ROLES.MARKETING, USER_ROLES.ACCOUNTING, USER_ROLES.CUSOMER_CARE, USER_ROLES.FRANCHISEE],
    },
  };

  return Object.keys(mapScreenToRolesAndPerm).some((screenPath) => {
    return (
      path.startsWith(screenPath) &&
      hasRole(mapScreenToRolesAndPerm[screenPath].roles) &&
      hasPermissions(mapScreenToRolesAndPerm[screenPath].permissions)
    );
  });
};

export const needRedirect = () => {
  const currentPath = window.location.pathname;
  const ordersPath = currentPath.match(new RegExp(`^(${SCREENS.CALLCENTER() + '/orders'}|${SCREENS.HISTORY()}|${SCREENS.LIVE_ORDERS()})`))?.[0];

  if (!ordersPath || _hasAccessToScreenByUser(ordersPath)) {
    return null;
  } else {
    return currentPath.replace(
      new RegExp(`^${ordersPath}`),
      userStore.user.role === USER_ROLES.CALL_CENTER_AGENT ? SCREENS.CALLCENTER() + '/orders' : SCREENS.LIVE_ORDERS()
    );
  }
};
